import { useState } from "react";
import { MapPin } from "@phosphor-icons/react";

export default function FounderCityDialog({ open, onSubmit, onCancel }) {
  const [city, setCity] = useState("");
  if (!open) return null;
  const submit = () => {
    const value = city.trim();
    if (value) onSubmit(value);
  };
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/80 px-6 backdrop-blur-sm"
      data-testid="founder-city-dialog">
      <div className="card-neon w-full max-w-sm p-6">
        <div className="flex items-center gap-2 text-neon-gold">
          <MapPin size={18} weight="fill" />
          <div className="font-display text-sm font-black uppercase tracking-wider">Where's your venue?</div>
        </div>
        <p className="mt-2 text-xs leading-relaxed text-zinc-400">
          Founders pricing is limited to the first 10 venues per city. We couldn't detect your
          location — type your city to check if a $49/yr founder spot is still available there.
        </p>
        <input data-testid="founder-city-input" autoFocus value={city} maxLength={80}
          onChange={(e) => setCity(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && submit()}
          placeholder="e.g. Austin"
          className="mt-4 w-full rounded-xl border border-white/10 bg-black px-4 py-2.5 text-sm outline-none focus:border-neon-gold" />
        <div className="mt-4 flex gap-2">
          <button data-testid="founder-city-submit" onClick={submit} disabled={!city.trim()}
            className="flex-1 rounded-full bg-neon-gold px-4 py-2.5 text-xs font-black text-black shadow-glow-gold disabled:opacity-40">
            Check My City
          </button>
          <button data-testid="founder-city-cancel" onClick={onCancel}
            className="rounded-full border border-white/10 px-4 py-2.5 text-xs font-bold text-zinc-400">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
